// extracted by mini-css-extract-plugin
module.exports = {"main-black":"#222","container":"CollapsedDrawer-module__container___3Rrrf","label":"CollapsedDrawer-module__label___3WY3W"};